import { Button } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { StickyCtaBar } from "web_myplann/Shared/Components/Redesign/StickyCtaBar";

type Props = {
	onApply: () => void;
};

export const FilterScreenApplyBar: FC<Props> = ({ onApply }) => {
	const { t } = useResource();

	return (
		<StickyCtaBar>
			<Button
				variant="primary"
				onClick={onApply}
				data-testid="notification-center-filter-apply"
			>
				{t(Resources.NotificationCenter.FilterScreen.Apply)}
			</Button>
		</StickyCtaBar>
	);
};
